const menu = {
    label: 'Usuários',
    icon: 'pi pi-fw pi-users',
    to: '/sol/usuarios',
    rules: ['SOL-001'],
};

export default menu;
